export default __webpack_public_path__ + "58c79eb859939f916362067fa2e63cb2.png";